import { c as _c } from "react/compiler-runtime";
import clsx from "clsx";
import type { ReactNode } from "react";
type NewsletterSignUpProps = {
  readonly className?: string;
  readonly children: ReactNode;
};
export function NewsletterSignUp(t0) {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = clsx("grid grid-cols-1 gap-x-2 overflow-hidden sm:grid-cols-12 print:hidden", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <article className={t1}>{children}</article>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
}